import { Component, Input } from '@angular/core';
import { BtnLinkComponent } from 'src/app/_shared/bloque-buttons/btn-link/btn-link.component';

@Component({
  selector: 'app-banner-lillian',
  standalone: true,
  imports: [
    BtnLinkComponent
  ],
  templateUrl: './banner-lillian.component.html',
  styleUrl: './banner-lillian.component.scss'
})
export class BannerLillianComponent {
  @Input() plataformaId: string;
  @Input() domainUrl: string;
  readonly slug: string = 'audiovisuales/invierte-cine-great-lillain-hall';
}
